/* ========================================
   PINFLAG - CÓDIGO PERSONALIZADO
   ======================================== */

/* ========================================
   CARRITO - RECOMENDACIONES
   ======================================== */

// Añade variante de bolsa al carro
function addToCartRecommended(button) {
  const span = button.querySelector(".cart-recommendations-text-button");
  if (span) span.textContent = "añadiendo...";

  const cartItem = button.closest(".cart-recommendations-cart-item");
  const variantInput = cartItem.getElementsByClassName("cart-recommendations-form-hidden");
  const variantId = variantInput[0] ? variantInput[0].value : null;

  if (variantId) {
    axios.post("/cart/add.js", { id: variantId, quantity: 1 })
      .then(() => {
        if (span) span.textContent = "agregar al carro";
        var bagMessage = cartItem.querySelector(".cart-recommendations-bag-message");
        if (bagMessage) bagMessage.setAttribute("style", "display: none !important;");
        button.setAttribute("style", "display: none !important;");
        var selectSizeBtn = cartItem.querySelector(".select-size-button");
        if (selectSizeBtn) selectSizeBtn.setAttribute("style", "display: block !important;");
        refreshCartDrawer();
      })
      .catch(function(error) {
        console.error("Error al agregar el producto al carrito:", error);
        if (span) span.textContent = "agregar al carro";
      });
  } else {
    console.error("No se encontró el variant ID.");
  }
}

//Actualiza visualmente el carro-----------------------------------------------------------------------------------
function refreshCartDrawer() {
  return fetch("/cart")
    .then((response) => response.text())
    .then((cart) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cart, "text/html");

      const cartItems = doc.querySelector("#cart-items-list");

      if (cartItems) {
        const cartItemList = document.querySelector("#cart-items-list");
        cartItemList.innerHTML = cartItems ? cartItems.innerHTML : "";

        const fsbNew = doc.querySelector("#CartDrawer .fsb");
        const fsbOld = document.querySelector("#CartDrawer .fsb");
        if (fsbNew && fsbOld && fsbOld.parentNode) {
          fsbOld.outerHTML = fsbNew.outerHTML;
        }

        const drawerFooter = doc.querySelector(".drawer__footer");
        const drawerFooterOld = document.querySelector(".drawer__footer");
        drawerFooterOld.innerHTML = drawerFooter ? drawerFooter.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      } else {
        const cartEmpty = doc.querySelector("cart-drawer");
        const cartEmptyOld = document.querySelector("cart-drawer");
        cartEmptyOld.innerHTML = cartEmpty ? cartEmpty.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      }
    })
    .catch((error) => console.error("Error updating cart drawer:", error));
}

document.querySelectorAll(".cart-recommendations-cart-item").forEach((card) => {
  const selectSizeButton = card.querySelector(".select-size-button");
  const addToCartButton = card.querySelector(
    ".cart-recommendations-button-add"
  );

  const closeButton = card.querySelector(".close-variants-buttons-recommended");
  const variantButtons = card.querySelector(
    ".cart-recommendations-bag-message"
  );

  selectSizeButton.addEventListener("click", () => {
    if (addToCartButton) {
      addToCartButton.setAttribute("style", "display: block !important;");
      selectSizeButton.setAttribute("style", "display: none !important;");
      variantButtons.setAttribute("style", "display: block !important;");
    }
  });

  closeButton.addEventListener("click", () => {
    if (variantButtons) {
      addToCartButton.setAttribute("style", "display: none !important;");
      selectSizeButton.setAttribute("style", "display: block !important;");
      variantButtons.setAttribute("style", "display: none !important;");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  // Crea un observer para detectar cambios en el DOM
  const observer = new MutationObserver(() => {
    // Verifica si el elemento '.cart-recommendations-cart-item' ha aparecido
    const items = document.querySelectorAll(".cart-recommendations-cart-item");
    
    if (items.length > 0) {
      items.forEach((item) => {
        // Aquí puedes ejecutar la lógica para trabajar con el nuevo item
        const selectSizeButton = item.querySelector(".select-size-button");
        const addToCartButton = item.querySelector(
          ".cart-recommendations-button-add"
        );
        const closeButton = item.querySelector(
          ".close-variants-buttons-recommended"
        );
        const variantButtons = item.querySelector(
          ".cart-recommendations-bag-message"
        );
        
        if (
          selectSizeButton &&
          addToCartButton &&
          closeButton &&
          variantButtons
        ) {
          selectSizeButton.addEventListener("click", () => {
            if (addToCartButton) {
              addToCartButton.setAttribute(
                "style",
                "display: block !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: none !important;"
              );
              variantButtons.setAttribute(
                "style",
                "display: block !important;"
              );
            }
          });
          
          closeButton.addEventListener("click", () => {
            if (variantButtons) {
              addToCartButton.setAttribute(
                "style",
                "display: none !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: block !important;"
              );
              variantButtons.setAttribute("style", "display: none !important;");
            }
          });
        }
      });
    }
  });
  
  // Configura el observer para observar el cuerpo del documento por cambios
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".card-wrapper .product-form__submit"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const drawerInner = document.querySelector(".drawer__inner");

      if (drawerInner) {
        const hasClasses =
          drawerInner.classList.contains("cart-drawer-pinflag-flex-column") &&
          drawerInner.classList.contains("cart-drawer-pinflag-width");

        if (!hasClasses) {
          drawerInner.classList.add(
            "cart-drawer-pinflag-flex-column",
            "cart-drawer-pinflag-width"
          );
        }
      }
    });
  });
});
/* ========================================
   CARRITO - OBSERVER DE WIDTH
   ======================================== */
document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const cartDrawer = document.querySelector("cart-drawer.drawer");
    if (cartDrawer) {
      clearInterval(interval);
      initCartObserver(cartDrawer);
    }
  }, 300);
});

function initCartObserver(cartDrawer) {
  function updateCart() {
    const drawerInner = document.querySelector(".drawer__inner");
    if (!drawerInner) return;

    const width = cartDrawer.classList.contains("is-empty") ? "40rem" : "72rem";
    drawerInner.style.setProperty("width", width, "important");
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        updateCart();
      }
    }
  });

  observer.observe(cartDrawer, { attributes: true });
  updateCart();
}

/* ========================================
   LOCAL STORAGE - USER INFORMATION
   ======================================== */
function formatRut(rut) {
  return rut.replace(/\./g, ""); // Elimina los puntos
}

function checkUserInformation() {
  const storedData = localStorage.getItem("userInformation");

  const userData = JSON.parse(storedData);
  const fullName = userData.names.split(" ");
  const first_name = fullName[0];
  const last_name = fullName.slice(1).join(" ");
  const email = userData.email;
  const rut = formatRut(userData.rut);

  exponea.update({
    first_name: first_name,
    last_name: last_name,
    rut: rut,
    email: email,
  });

  exponea.identify({
    email_id: email,
  });
}

/* ========================================
   VARIANTES - SELECTOR
   ======================================== */

function updateSelectedVariant(button, cart = false) {
  if (!cart) {
    const productCard = button.closest(".product-card-wrapper");
    const selectedVariantId = button.dataset.variantId;
    const hiddenVariantInput = productCard.querySelector(
      ".selected-variant-id"
    );
    const submitButton = productCard.querySelector(".product-form__submit");
    hiddenVariantInput.value = selectedVariantId;

    const variantButtons = productCard.querySelectorAll(".variant-button");

    variantButtons.forEach((btn) => {
      btn.classList.toggle(
        "selected",
        btn.dataset.variantId === selectedVariantId
      );
    });

    if (submitButton) {
      submitButton.disabled = false;
      const span = submitButton.querySelector("span");
      if (span) {
        span.textContent = submitButton.dataset.labelAdd || "agregar al carro";
      }
    }
  } else {
    const cartItem = button.closest(".cart-recommendations-cart-item ");

    const selectedVariantId = button.dataset.variantId;

    const hiddenVariantInput = cartItem.querySelector(
      ".cart-recommendations-form-hidden"
    );

    hiddenVariantInput.value = selectedVariantId;

    const variantButtons = cartItem.querySelectorAll(".variant-button");

    variantButtons.forEach((btn) => {
      btn.classList.toggle(
        "selected",
        btn.dataset.variantId === selectedVariantId
      );
    });
  }
}

